import { useCallback, useState } from "react";
import { Avatar } from "@heroui/react";
import { useNavigate } from "react-router-dom";
import { CustomModal, EmptyState } from "../shared";
import SearchBar from "../shared/SearchBar";

const PartnerChatModal = ({
    openPartnerChatModal,
    setOpenPartnerChatModal,
    allUsersMembers,
}) => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState(null);
    const [searchUserListing, setSearchUserListing] = useState([]);

    const handleChatSearch = useCallback(
        (value) => {
            if (!value) {
                setSearchQuery(value);
                setSearchUserListing([]);
            } else {
                const searchListingArray = allUsersMembers?.filter((user) =>
                    user?.name?.toLowerCase()?.includes(value?.toLowerCase())
                );
                setSearchQuery(value);
                setSearchUserListing([...searchListingArray]);
            }
        },
        [allUsersMembers]
    );

    const handlePartnerSelect = (item) => {
        // Navigate to chat with selected partner
        navigate(`/chat`, {
            state: {
                user_id: item?.id,
                completeItem: {
                    avatar: item?.avatar || "",
                    channel_id: null,
                    chatType: "individual",
                    id: item?.id,
                    name: item?.name || "",
                    online: false,
                    selected: false,
                },
            },
        });
        setOpenPartnerChatModal(false);
        setSearchQuery(null);
    };

    const displayList = searchQuery?.length > 0 ? searchUserListing : allUsersMembers;

    return (
        <div>
            <CustomModal
                title={"New Chat"}
                open={openPartnerChatModal}
                close={() => {
                    setOpenPartnerChatModal(false);
                    setSearchQuery(null);
                }}
                showPrimaryButton={false}
                showSecondaryButton={false}
            >
                <div className="h-[calc(100vh-290px)] overflow-hidden">
                    <div className="h-full flex flex-col">
                        <div className="py-3">
                            <SearchBar
                                className={"bg-surface-hover rounded"}
                                variant={"bordered"}
                                value={searchQuery || ""}
                                onValueChange={handleChatSearch}
                                placeholder={"Search"}
                                onClear={() => {
                                    setSearchQuery("");
                                }}
                            />
                        </div>

                        <div className="flex-1 overflow-y-auto overflow-x-hidden">
                            {displayList?.length > 0 ? (
                                displayList.map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center gap-3 p-4 hover:bg-surface cursor-pointer rounded-lg transition-colors"
                                        onClick={() => handlePartnerSelect(item)}
                                    >
                                        <Avatar
                                            src={item?.avatar}
                                            classNames={{
                                                base: "bg-mediumgrey/30",
                                                icon: "text-black/60",
                                            }}
                                        />
                                        <h3 className="font-medium text-primary">{item?.name}</h3>
                                    </div>
                                ))
                            ) : (
                                <div className="h-full flex items-center justify-center">
                                    <EmptyState
                                        title="No connections found"
                                        description="Try a different search to find someone to chat with."
                                        compact
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

export default PartnerChatModal;
